import Vehicles from '@/components/features/vehicles/Vehicles';
import { createFileRoute } from '@tanstack/react-router';
import i18next from 'i18next';
import { z } from 'zod';

const vehiclesSearchSchema = z.object({
  project_ids: z.string().optional(),
});

const VehiclesPage = () => {
  return <Vehicles />;
};

export const Route = createFileRoute('/vehicles/')({
  validateSearch: (search) => vehiclesSearchSchema.parse(search),
  head: () => ({
    meta: [
      {
        title: `${i18next.t('vehicles.title')} | Vehicle Console`,
      },
    ],
  }),
  component: VehiclesPage,
});
